export const defaultPreferencesFields = {
  select_all: false,
  shipment_booked: false,
  picked_up: false,
  eta_changed: false,
  delayed: false,
  cancellation: false,
  delivered: false
};
